module.exports = __webpack_public_path__ + "media/images/footer_github-080554f388b33089654078bba4b74dd8.png";